import authAxios from "./api";
import TokenService from "./token.service";

const REST_API_URL_PREFIX = "http://85.159.27.198:8080/abitur/api/v1";

export class FinalAssessmentService {
  static updateFinalAssessment(assessmentId, requestBody) {
    return authAxios.put(
      `${REST_API_URL_PREFIX}/final-assessment/update/${assessmentId}`,
      requestBody
    );
  }

  static createFinalAssessment(requestBody) {
    return authAxios.post(
      `${REST_API_URL_PREFIX}/final-assessment/create`,
      requestBody
    );
  }

  static getFinalAssessmentByStudentId(studentId) {
    return authAxios.get(
      `${REST_API_URL_PREFIX}/final-assessment/get-by-student/${studentId}`
    );
  }

  static getFinalAssessmentByStudentIdAndStreamId(studentId, streamId) {
    return authAxios.get(
      `${REST_API_URL_PREFIX}/final-assessment/get-by-stream-and-student?studentId=${studentId}&streamId=${streamId}`
    );
  }

  static getFinalAssessmentByStreamId(streamId) {
    return authAxios.get(
      `${REST_API_URL_PREFIX}/final-assessment/get-by-streamid/${streamId}`
    );
  }
  static getExamAssessmentByStreamId(streamId) {
    return authAxios.get(
      `${REST_API_URL_PREFIX}/exam-assessment/get-by-streamid/${streamId}`
    );
  }
  static createExamAssessmentByStreamId(requestBody) {
    return authAxios.post(
      `${REST_API_URL_PREFIX}/exam-assessment/create`, requestBody
    );
  }
  static updateExamAssessmentByStreamId(assessmentId, requestBody) {
    return authAxios.put(
      `${REST_API_URL_PREFIX}/exam-assessment/update/${assessmentId}`, requestBody
    );
  }
  static getFinalExamAssessmentByStreamId(streamId) {
    return authAxios.get(
      `${REST_API_URL_PREFIX}/final-exam-assessment/get-by-streamid/${streamId}`
    );
  }
  static createFinalExamAssessmentByStreamId(requestBody) {
    return authAxios.post(
      `${REST_API_URL_PREFIX}/final-exam-assessment/create`, requestBody
    );
  }
  static updateFinalExamAssessmentByStreamId(assessmentId, requestBody) {
    return authAxios.put(
      `${REST_API_URL_PREFIX}/final-exam-assessment/update/${assessmentId}`, requestBody
    );
  }

  static deleteFinalAssessmentByAssessmentId(assessmentId) {
    return authAxios.delete(
      `${REST_API_URL_PREFIX}/final-assessment/delete/${assessmentId}`
    );
  }
}
